import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './features/counterSlice';
import layoutReducer from './features/layoutSlice';
import eventReducer from './features/eventSlice';
import userReducer from './features/userSlice';
import newsReducer from './features/newsSlice';
import representativesReducer from './features/representativesSlice';
import streamingSocketReducer from './streamingSocket/streamingSocketSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    layout: layoutReducer,
    user: userReducer,
    news: newsReducer,
    representatives: representativesReducer,
    streamingSocket: streamingSocketReducer,
    event: eventReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;